import React, { useContext } from 'react';
import Header from '../../components/Header/Header';
import useTranslation from '../../hooks/useTranslation';
import { TranslationContext } from '../../helpers/Context';
import './acronyms.css';

const Acronyms = () => {
  const T = useTranslation();
  const { language } = useContext(TranslationContext);

  // Datos de los acrónimos organizados por categorías
  const acronymsData = {
    rhythm: [
      { acronym: 'AESP', meaning: 'AESP_meaning' },
      { acronym: 'FV', meaning: 'FV_meaning' },
      { acronym: 'TSV', meaning: 'TSV_meaning' },
      { acronym: 'TVCP', meaning: 'TVCP_meaning' },
      { acronym: 'TVSP', meaning: 'TVSP_meaning' },
      { acronym: 'Sinusal', meaning: 'Sinusal_meaning' },
    ],
    blocks: [
      { acronym: 'Bloq. 1º', meaning: 'Bloq1_meaning' },
      { acronym: 'Bloq. 2º I', meaning: 'Bloq2I_meaning' },
      { acronym: 'Bloq. 2º II', meaning: 'Bloq2II_meaning' },
      { acronym: 'Bloq. 3º', meaning: 'Bloq3_meaning' },
    ],
    procedures: [
      { acronym: 'PCR', meaning: 'PCR_meaning' },
      { acronym: 'RCP', meaning: 'RCP_meaning' },
      { acronym: 'RCE', meaning: 'RCE_meaning' },
      { acronym: 'IOT', meaning: 'IOT_meaning' },
      { acronym: 'IOT/DSG', meaning: 'IOT_DSG_meaning' },
      { acronym: 'DSG', meaning: 'DSG_meaning' },
      { acronym: 'DEA', meaning: 'DEA_meaning' },
      { acronym: 'ECG', meaning: 'ECG_meaning' },
      { acronym: 'OVACE', meaning: 'OVACE_meaning' },
    ],
  };

  const renderAcronymCard = (acronym, meaningKey) => (
    <div key={acronym} className="acronym-card">
      <div className="acronym-header">
        <div className="acronym-badge">{acronym}</div>
        <div className="acronym-meaning">{T(meaningKey)}</div>
      </div>
    </div>
  );

  const renderCategory = (title, acronyms, description) => (
    <div key={title} className="acronym-category">
      <h3 className="category-title">{title}</h3>
      <p className="category-description">{description}</p>
      <div className="acronyms-grid">
        {acronyms.map(({ acronym, meaning }) => 
          renderAcronymCard(acronym, meaning)
        )}
      </div>
    </div>
  );

  return (
    <div>
      <Header />
      <div className="acronyms-container">
        <h1 className="acronyms-title">{T('acronyms_title')}</h1>
        <p className="acronyms-description">{T('acronyms_description')}</p>
        
        {renderCategory(
          language === 'ES' ? 'Ritmos Cardíacos' : 
          language === 'EN' ? 'Cardiac Rhythms' :
          language === 'IT' ? 'Ritmi Cardiaci' : 'Ritmos Cardíacos',
          acronymsData.rhythm,
          language === 'ES' ? 'Acrónimos relacionados con los diferentes ritmos cardíacos y arritmias' :
          language === 'EN' ? 'Acronyms related to different cardiac rhythms and arrhythmias' :
          language === 'IT' ? 'Acronimi relativi ai diversi ritmi cardiaci e aritmie' : 
          'Acrónimos relacionados com os diferentes ritmos cardíacos e arritmias'
        )}
        
        {renderCategory(
          language === 'ES' ? 'Bloqueos Cardíacos' : 
          language === 'EN' ? 'Heart Blocks' :
          language === 'IT' ? 'Blocchi Cardiaci' : 'Bloqueios Cardíacos',
          acronymsData.blocks,
          language === 'ES' ? 'Acrónimos relacionados con los diferentes tipos de bloqueo cardíaco' :
          language === 'EN' ? 'Acronyms related to different types of heart block' :
          language === 'IT' ? 'Acronimi relativi ai diversi tipi di blocco cardiaco' : 
          'Acrónimos relacionados com os diferentes tipos de bloqueio cardíaco'
        )}
        
        {renderCategory(
          language === 'ES' ? 'Procedimientos y Dispositivos' : 
          language === 'EN' ? 'Procedures and Devices' :
          language === 'IT' ? 'Procedure e Dispositivi' : 'Procedimentos e Dispositivos',
          acronymsData.procedures,
          language === 'ES' ? 'Acrónimos relacionados con procedimientos médicos y dispositivos utilizados en reanimación' :
          language === 'EN' ? 'Acronyms related to medical procedures and devices used in resuscitation' :
          language === 'IT' ? 'Acronimi relativi a procedure mediche e dispositivi utilizzati nella rianimazione' : 
          'Acrónimos relacionados com procedimentos médicos e dispositivos utilizados na reanimação'
        )}
      </div>
    </div>
  );
};

export default Acronyms; 